<template>
    <form id="ProjectExperienceForm" class="needs-validation" novalidate>
        <div class="row g-3">
            <!-- Role Field -->
            <div class="col-md-4">
                <label for="role"><strong>{{ $Translate('role') }}: </strong><span class="text-danger">*</span></label>
                <input type="text" id="role" class="form-control" :placeholder="$Translate('rolePlaceholder')"
                    :class="{ 'is-valid': projExpSubmitted && roleIsValid, 'is-invalid': projExpSubmitted && !roleIsValid }"
                    v-model="projectExperience.role" name="role" required />
            </div>

            <!-- From Date Field -->
            <div class="col-md-4">
                <label for="startDateProjectExperience"><strong>{{ $Translate('startDate') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="date" id="startDateProjectExperience" class="form-control"
                    :class="{ 'is-valid': projExpSubmitted && startDateProjectExperienceIsValid, 'is-invalid': projExpSubmitted && !startDateProjectExperienceIsValid }"
                    v-model="projectExperience.startDateProjectExperience" name="startDateProjectExperience" required />
            </div>

            <!-- To Date Field -->
            <div class="col-md-4">
                <label for="endDateProjectExperience"><strong>{{ $Translate('endDate') }}:
                    </strong><span class="text-danger">*</span></label>
                <input type="date" id="endDateProjectExperience" class="form-control"
                    :class="{ 'is-valid': projExpSubmitted && endDateProjectExperienceIsValid, 'is-invalid': projExpSubmitted && !endDateProjectExperienceIsValid }"
                    v-model="projectExperience.endDateProjectExperience" name="endDateProjectExperience" required />
            </div>

            <!-- Description Field -->
            <div class="col-md-4">
                <label for="descriptionProjectExperience"><strong>{{ $Translate('description') }}:
                    </strong></label>
                <textarea id="descriptionProjectExperience" class="form-control"
                    :class="{ 'is-valid': projExpSubmitted && descriptionProjectExperienceIsValid, 'is-invalid': projExpSubmitted && !descriptionProjectExperienceIsValid }"
                    v-model="projectExperience.descriptionProjectExperience" name="descriptionProjectExperience" />
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: 'ProjectExperience',
    props: {
        projectExperience: Object,
        projExpSubmitted: Boolean,
        projectExperienceList: Array,
        roleIsValid: Boolean,
        startDateProjectExperienceIsValid: Boolean,
        endDateProjectExperienceIsValid: Boolean,
        descriptionProjectExperienceIsValid: Boolean
    }
}
</script>

<style scoped>
.col-md-4 {
    text-align: start;
}

.col-md-4 label {
    margin-bottom: 10px;
}

.col-md-4 input,
.col-md-4 select,
.col-md-4 textarea {
    margin-bottom: 12px;
}

.col-md-4 select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('../../../../dist/assets/select.svg') no-repeat right 0.75rem center;
    background-color: #fff;
    background-size: 16px 16px;
    padding-right: 2rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
}
</style>